module.exports = __webpack_public_path__ + "static/media/img3.1d72816e.png";